<template>
  <div>
    <div class="flex space-x-4 items-end">
      <BaseFormGroup>
        <BaseFormLabel> Date range </BaseFormLabel>
        <div>
          <BaseFormSelect
            v-model="dateRange"
            :options="[
              { label: 'Preset', value: 'preset' },
              { label: 'Custom', value: 'custom' },
            ]"
            required
            class="bg-white"
            @change="changePreset"
          />
        </div>
      </BaseFormGroup>

      <BaseFormGroup v-if="dateRange === 'preset'">
        <BaseFormLabel> Date preset </BaseFormLabel>
        <div>
          <BaseFormSelect
            v-model="datePreset"
            :options="datePresetOptions"
            required
            class="bg-white"
            @change="changeDateRange"
          />
        </div>
      </BaseFormGroup>

      <template v-if="dateRange === 'custom'">
        <BaseFormGroup>
          <BaseFormLabel> Date from </BaseFormLabel>
          <div>
            <BaseFormInput v-model="since" type="date" class="bg-white" />
          </div>
        </BaseFormGroup>

        <BaseFormGroup>
          <BaseFormLabel> Date to </BaseFormLabel>
          <div>
            <BaseFormInput v-model="until" type="date" class="bg-white" />
          </div>
        </BaseFormGroup>
      </template>

      <div class="p-px">
        <BaseButton
          primary
          class="h-10"
          :disabled="dateDiff < 0 || dateDiff > 30"
          @click="handleSubmit"
        >
          Submit
        </BaseButton>
      </div>

      <div class="p-px">
        <BaseButton ghost class="h-10" @click="handleReset"> Reset </BaseButton>
      </div>
    </div>
    <BaseFormInlineMessage danger v-if="dateDiff < 1">
      Date 'until' must come after 'since' at least 1 day
    </BaseFormInlineMessage>
    <BaseFormInlineMessage danger v-if="dateDiff > 30">
      Date period cannot be more than 30 days
    </BaseFormInlineMessage>
  </div>
</template>

<script>
import moment from 'moment';
import { datePresets } from '@/utils/instagram-insights-query-params';

export default {
  data() {
    return {
      dateRange: 'preset',
      datePreset: datePresets[0].value,
      datePresetOptions: [...datePresets],
      since: null,
      until: null,
    };
  },
  computed: {
    dateDiff() {
      return moment(this.until).diff(this.since, 'days');
    },
  },
  created() {
    this.handleReset();
    this.handleSubmit();
  },
  methods: {
    handleSubmit() {
      this.$emit('query', {
        since: this.since,
        until: this.until,
      });
    },
    setRange(since = moment().format('YYYY-MM-DD'), until = moment().format('YYYY-MM-DD')) {
      this.since = since;
      this.until = until;
    },
    handleReset() {
      const initial = datePresets[0];
      const [since, until] = initial.value.split(',');
      this.dateRange = 'preset';
      this.datePreset = initial.value;
      this.setRange(since, until);
    },
    changeDateRange(ev) {
      const [since, until] = (ev?.target?.value || '').split(',');
      this.setRange(since, until);
    },
    changePreset() {
      const initial = datePresets[0];
      const [since, until] = initial.value.split(',');
      this.datePreset = initial.value;
      this.setRange(since, until);
    },
  },
};
</script>
